/**
 * dc-runtime parity helpers used by the generated views (tools/dc-port). The style/attribute helpers live in
 * `@pointfive/ui` so the library and the generated views build byte-identical style attributes; `t()` (JSX text
 * interpolation) stays here because it renders React elements.
 * Mirrors design-reference/support.js so the React render is DOM-identical to the reference render.
 */
import { Fragment, isValidElement, type ReactNode } from 'react';
export { s, css, cssAny, a, b, n, tx, cx, styleOf } from '@pointfive/ui';
import { a as attr } from '@pointfive/ui';

/** Text interpolation (walkText): elements/arrays pass through; null/boolean/undefined render nothing;
 *  everything else renders inside <span class="sc-interp">. */
export function t(value: unknown): ReactNode {
  if (value === undefined || value === null || typeof value === 'boolean') return null;
  if (isValidElement(value) || Array.isArray(value)) return <Fragment>{value as ReactNode}</Fragment>;
  return <span className="sc-interp">{String(value)}</span>;
}
/** `value="{{ x }}"` special-case: undefined → ''. */
export function v(value: unknown): string | number | readonly string[] {
  if (value === undefined || value === null) return '';
  if (typeof value === 'number') return value;
  return String(value as string | boolean);
}
export { attr as __attr };
